var Location = /** @class */ (function () {
    function Location() {
        this._currentPageOptions = {};
        this.hash = '';
    }
    Location.prototype.__updatePageOption = function (pageOptions) {
        this._currentPageOptions = pageOptions;
    };
    Location.prototype.__updatePageId = function (pageId) {
        this._pageId = pageId;
    };
    Object.defineProperty(Location.prototype, "href", {
        get: function () {
            return this.pathname + this.search;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "search", {
        get: function () {
            var _this = this;
            var search = '';
            Object.keys(this._currentPageOptions).forEach(function (key, index) {
                var query = "".concat(key, "=").concat(_this._currentPageOptions[key]);
                search += index === 0 ? '?' : '&';
                search += query;
            });
            return search;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "pathname", {
        get: function () {
            // eslint-disable-next-line no-undef
            var pages = getCurrentPages();
            if (pages.length === 0)
                return '';
            var currentPage = pages[pages.length - 1];
            return addLeadingSlash(currentPage.route);
        },
        enumerable: false,
        configurable: true
    });
    return Location;
}());
export default Location;
function addLeadingSlash(str) {
    return str[0] === '/' ? str : '/' + str;
}
